import { useMemo } from 'react'
import { useAccount } from 'wagmi'
import { useTokenAllowance } from '~/hooks/useTokenAllowance'
import { parseUnits } from 'viem'
import { stETH } from '~/constants/tokens'
import { WSTETH_ADDRESS } from '~/constants/addresses'
import { Mainnet } from '~/model/chain/ethereum'

export const useIsStEthNeedApprove = (amount: string) => {
  const { address: account, chainId } = useAccount()
  const allowance = useTokenAllowance(stETH, account, WSTETH_ADDRESS)

  const isNeedApprove = useMemo(() => {
    if (!account || chainId !== Mainnet.chainId) return false
    const formattedAllowance = allowance ? allowance.toNumber() : 0
    return parseUnits(amount, stETH.decimals) > BigInt(formattedAllowance)
  }, [account, amount, allowance, chainId])

  return isNeedApprove
}
